<template lang="pug">
  app-page(title="Заявки на оплату" :loading="loading")
    listToolbar

    // AdvocatApps list 
    //
    div
      v-layout(row wrap v-if="appList.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in appList" :key="index"  )
          advocatAppCard(@click.native="showAppDetail(a)" :advocatApp="a" :fromAdvocat="false" :isBuh="isBuh" @toggle="toggleApp")
    
    app-empty-list(v-if="isAppsLoaded && appList.length == 0")
      div Не найдено ни одной заявки
      div Со статусом: {{ selectedStatus | statusNamed }}
      div За период: {{ period | periodNamed }}

    app-button-action(v-if="selectedApp.length>0" @click="makeReestr()" :disabled="!ready" fixed bottom center) 
      | сформировать реестр


</template>

<script>
import listToolbar from './components/ListToolbar'
import advocatAppCard from './advocat/components/AdvocatAppCard'
import moment from 'moment'
moment.locale('ru');

import { $_app_moment } from "@/common/AppMoment.js"
import { $_user_role as Role } from '@/common/UserUtils'
import { specialistService } from '@/_services'

import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [ $_app_moment ],
  components: {
    listToolbar,
    advocatAppCard
  },

  data () {
    return {
      selectedApp: [],
      ready: true 
    }
  },

  methods: {
    showAppDetail(selectedApp) {
      this.$router.push({name: 'AppDetail', params: {appId: selectedApp.id}})
    },
    toggleApp(id) {
      let pos = this.selectedApp.indexOf(id)
      if(pos > -1)
          this.selectedApp.splice(pos, 1)
      else
          this.selectedApp.push(id)
    },
    makeReestr() {
      this.ready = false
      specialistService.makeReestr(this.selectedApp).then( () =>{
         this.ready = true
         this.$router.push({name: 'SpecialistReestr'})
      })
    }
  },


  filters: {
    statusNamed: status => {
      return status != null ? status.title : 'Все'
    },
    periodNamed: function (period) {
      return period != null ? period.text : 'Все'
    }
  },


  computed: {
    ...mapState('specialist', ['selectedStatus', 'period']),
    ...mapGetters('specialist', ['apps','isAppsLoaded']),
    ...mapGetters('me', ['hasRole']),
    isBuh() {
      return this.hasRole([Role.accountant])
    },

    loading () {
      return !this.isAppsLoaded || !this.ready
    },

    appList() {
      let list = (this.selectedStatus == null) ? this.apps : this.apps.filter(c => c.appStatus.value == this.selectedStatus.value)

      if (this.period) {
        list = list.filter(item => moment(item.createDate).isBetween(this.period.start, this.period.end, 'day', '[]'))
      }

      return list
    }
  },
  created() {
    if(this.hasRole([Role.accountant]))
        this.$store.dispatch('specialist/INIT', { defaultStatus: 'CONFIRM' })
    else
        this.$store.dispatch('specialist/INIT', { defaultStatus: 'SEND' })
  }
}


</script>

<style scoped>
</style>
